<template>
  <div id="DummyChangeRegistModal">
    <div class="modal-card" style="width: 900px; height: 700px;">
      <header class="modal-card-head">
        <p class="modal-card-title" style="color: whitesmoke; text-align:left">
          暫定ユーザーを以下のユーザーに紐づけます。<br>
          誤ったユーザーと紐づけた場合、情報漏洩になりますので、<br>
          十分にご確認をお願いします。<br>
          確認し問題ない場合は、OKボタンを押してください。
        </p>
      </header>
      <section class="modal-card-body">
        <!--表示情報 -->
        <div class="condition-area">
          <table class="dummyTable">
            <tr>
              <th></th>
              <th class="dummy-th">暫定ユーザー</th>
              <th class="linked-th">紐づけ先ユーザー</th>
              <th></th>
            </tr>
            <tr class="medicalIdRow">
              <td style="width:15%">組織ID</td>
              <td style="width:40%"> 
                <input style="border: none" type="text" class="nameInput" v-model="dummyInfo.belongInfo.id" disabled/>
              </td>
              <td style="width:40%"> 
                <input style="border: none" type="text" class="nameInput" v-model="linkedInfo.belongInfo.id" disabled/>
              </td>
              <td style="width:2%">
              </td>
            </tr>
            <tr>
              <td>施設名</td>
              <td> 
                <input style="border: none" type="text" class="nameInput" v-model="dummyInfo.belongInfo.medicalInstitutionName" disabled/>
              </td>
              <td> 
                <input style="border: none" type="text" class="nameInput" v-model="linkedInfo.belongInfo.medicalInstitutionName" disabled/>
              </td>
              <td>
                <b-checkbox  class="medicalCheckBox" v-model="isMedicalName" value="false"></b-checkbox>
              </td>
            </tr>
            <tr>
              <td>住所</td>
              <td>
                <input style="border: none" type="text" class="addressInput" :value="dummyAddress" disabled>
              </td>
              <td>
                <input style="border: none" type="text" class="addressInput" :value="linkedAddress" disabled>
              </td>
              <td>
                <b-checkbox  class="adressCheckBox" v-model="isAddress" value="false"></b-checkbox>
              </td>
            </tr>
            <tr>
              <td>得意先コード</td>
              <td>
                <input style="border: none" type="text" class="nameInput" v-model="dummyInfo.belongInfo.customerId" disabled/>
              </td>
              <td>
                <input style="border: none" type="text" class="nameInput" v-model="linkedInfo.belongInfo.customerId" disabled/>
              </td>
              <td>
                <b-checkbox  class="codeCheckBox" v-model="isMedicalCode" value="false"></b-checkbox>
              </td>
            </tr>
            <tr>
              <td>担当営業所</td>
              <td>
                <input style="border: none" type="text" class="nameInput" v-model="dummySalesOfficeName" disabled/>
              </td>
              <td>
                <input style="border: none" type="text" class="nameInput" v-model="linkedSalesOfficeName" disabled/>
              </td>
              <td>
                <b-checkbox  class="salesOfficeCheckBox" v-model="isSalesOffice" value="false"></b-checkbox>
              </td>
            </tr>
            <tr>
              <td>担当者</td>
              <td>
                <input style="border: none" type="text" class="nameInput" v-model="dummyInfo.belongInfo.salesStaffName" disabled/>
              </td>
              <td>
                <input style="border: none" type="text" class="nameInput" v-model="linkedSalesStaffName" disabled/>
              </td>
              <td>
                <b-checkbox  class="salesStaffCheckBox" v-model="isSalesStaff"></b-checkbox>
              </td>
            </tr>
          </table>
        </div>
      </section>
      <footer class="modal-card-foot custom-footer">
        <button class="button" type="button" @click="$parent.close()">戻る</button>
        <button class="button ok-button" type="button" :disabled="singleCheck()" @click="regist">OK</button>
      </footer>
    </div>
  </div>
</template>
<script>
import {service} from "@/components/mock/base/const.js";
export default {
  name: "DummyChangeRegistModal",
  props: {
    linkedInfo: {default: ""},
    dummyInfo: {default: ""},
  },
  methods: {
    singleCheck: function() {
      if(this.isMedicalName && this.isAddress && this.isMedicalCode && this.isSalesOffice && this.isSalesStaff){
        return false
      }
      return true
    },
    regist: function() {
      this.$emit('select');
      this.$parent.close();
    },
  },

  data() {
    var salesOfficeMaster = this.getSalesOfficeMaster();
    salesOfficeMaster.unshift({});
    var dummySalesOfficeInfo = salesOfficeMaster.find(item => item.code === this.dummyInfo.belongInfo.salesOfficeCode);
    var dummySalesOfficeName = dummySalesOfficeInfo.name;
    var linkedSalesOfficeInfo, linkedSalesOfficeName, linkedSalesStaffName;
    // QA493 紐づけ先の本登録ユーザーがCPAPサービスチェックONかつCPAP営業所＆CPAP担当営業が登録されている場合、その値を表示
    // それ以外の場合は、営業所＆営業員は「未登録」を表示
    if (this.linkedInfo.belongInfo.cpapSalesOfficeCode && (this.linkedInfo.belongInfo.useService & service.cpap) == service.cpap) {
      linkedSalesOfficeInfo = salesOfficeMaster.find(item => item.code === this.linkedInfo.belongInfo.cpapSalesOfficeCode);
      linkedSalesOfficeName = linkedSalesOfficeInfo.name;
    } else {
      linkedSalesOfficeName = '未登録';
    }
    if (this.linkedInfo.belongInfo.cpapSalesStaffName && (this.linkedInfo.belongInfo.useService & service.cpap) == service.cpap) {
      linkedSalesStaffName = this.linkedInfo.belongInfo.cpapSalesStaffName;
    } else {
      linkedSalesStaffName = '未登録';
    }
    return {
      salesOfficeMaster:salesOfficeMaster,
      isMedicalId: false,
      isMedicalName: false,
      isAddress: false,
      isMedicalCode: false,
      isSalesOffice: false,
      isSalesStaff: false,
      dummySalesOfficeName: dummySalesOfficeName,
      linkedSalesOfficeName: linkedSalesOfficeName,
      linkedSalesStaffName: linkedSalesStaffName,
    };
  },
  filters: {},
  components: {},
  mounted: function () {
  },
  computed: {
    dummyAddress: function() {
      return `${this.dummyInfo.belongInfo.customerPostCode} ${this.dummyInfo.belongInfo.prefecture} ${this.dummyInfo.belongInfo.city} ${this.dummyInfo.belongInfo.customerAddress1} ${this.dummyInfo.belongInfo.customerAddress2}`
    },
    linkedAddress: function() {
      return `${this.linkedInfo.belongInfo.customerPostCode} ${this.linkedInfo.belongInfo.prefecture} ${this.linkedInfo.belongInfo.city} ${this.linkedInfo.belongInfo.customerAddress1} ${this.linkedInfo.belongInfo.customerAddress2}`
    }
  }
};
</script>
<style lang="scss" scoped>
table.dummyTable {
  border: none;
  // border-collapse: collapse;
  width: 100%;
  border-collapse: separate;
  border-spacing: 20px;
}
table.dummyTable > tr {
  border: none;
  height: 30px;
}
table.dummyTable >tr> th,
table.dummyTable >tr> td {
  border: none;
  vertical-align : middle;
  padding:5px;
}
table.dummyTable >tr> th {
  text-align: left;
  font-weight: bold; 
  font-size: 25px; 
  width: 100px;
}
table.dummyTable >tr> td {
  width: 200px;
}
.addressInput {
  width: 100% !important;
}
.custom-footer {
  position: relative;
  display: flex;
  align-items: center;
}
.ok-button {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/common/DummyChangeRegistModal.vue